// extracted by mini-css-extract-plugin
export var addressFields = "_fu-0";
export var animationContainer = "_fu-1";
export var footer = "_fu-2";
export var lineItems = "_fu-3";
export var modalContent = "_fu-4";
export var orderName = "_fu-5";
export var strong = "_fu-6";
export var warning = "_fu-7";